import { render } from "./assessment-panel.vue?vue&type=template&id=6287c614&scoped=true&ts=true"
import script from "./assessment-panel.vue?vue&type=script&lang=ts"
export * from "./assessment-panel.vue?vue&type=script&lang=ts"

import "./assessment-panel.vue?vue&type=style&index=0&id=6287c614&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6287c614"]])

export default __exports__